export class PNEC {
    bySubstance: any // TODO: add type

    constructor(pnecsFiltered: any) {
        this.bySubstance = pnecsFiltered
    }
}